import { CustomExceptionProps, HttpException } from './http-exception';

export class HttpNetworkError extends HttpException {
  static readonly STATUS = 0;
  static readonly TYPE = 'Network error';
  static readonly NAME = 'HttpNetworkError';

  constructor(props: CustomExceptionProps) {
    super({ type: HttpNetworkError.TYPE, ...props, status: HttpNetworkError.STATUS });
    Object.setPrototypeOf(this, HttpNetworkError.prototype);
    this.name = HttpNetworkError.NAME;
  }
}
